import { render, staticRenderFns } from "./ProductAlternativeCard.vue?vue&type=template&id=6a170048&scoped=true&"
import script from "./ProductAlternativeCard.vue?vue&type=script&lang=js&"
export * from "./ProductAlternativeCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductAlternativeCard.vue?vue&type=style&index=0&id=6a170048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a170048",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
